import { render } from "./tiposdesangre.vue?vue&type=template&id=0cbfe1d1"
import script from "./tiposdesangre.vue?vue&type=script&lang=js"
export * from "./tiposdesangre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__